import FormViewForm from '@src/components/_forms/FormViewForm';
import {IExternalApplicationModel} from '@src/@interfaces/models/ExternalApplication/IExternalApplicationModel';
import ExternalApplicationTokensField from '@views/external-applications/fields/ExternalApplicationTokensField';
import React from 'react';

export const ExternalApplicationPluginsFieldLazy = React.lazy(
        () => import('@views/external-applications/fields/ExternalApplicationPluginsField')
);

const customFields = {
    tokens: {
        component: ExternalApplicationTokensField as any,
    },
    plugins: {
        component: ExternalApplicationPluginsFieldLazy as any,
    },
};

export default class ExternalApplicationForm<Model extends IExternalApplicationModel> extends FormViewForm<Model> {
    protected get customFields() {
        return customFields;
    }

    protected mutateModelFieldInitialValue(fieldName: string, modelValue: any): any {
        if (['tokens', 'plugins'].includes(fieldName)) {
            return modelValue ?? [];
        }

        return super.mutateModelFieldInitialValue(fieldName, modelValue);
    }
}
